import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Tree from 'components/Tree'
import { useQuery } from 'components/graphql'
import query from 'gql/query/cashRegistersTree'

import CashRegister from './CashRegister'
import Shop from './Shop'
import Region from './Region'
import Department from './Department'

const CashRegisterTree = ({ cardsInRow = 2, onOldCrIconClick, includeOutOfOrder, ...props }) => {
	const [t] = useTranslation()
	const { data } = useQuery(query, {
		fetchPolicy: 'cache-first',
		variables: {
			includeOutOfOrder
		}
	})
	const NodeComponent = useCallback(nodeProps => {
		const { nodeData, children } = nodeProps
		switch (nodeData.__typename) {
			case 'Department':
				return (
					<Department {...nodeProps} cardsInRow={cardsInRow}/>
				)
			case 'Region':
				return (
					<Region {...nodeProps}/>
				)
			case 'Shop':
				return (
					<Shop {...nodeProps}/>
				)
			case 'CashRegister':
				return (
					<CashRegister onOldCrIconClick={onOldCrIconClick} {...nodeProps}/>
				)
			default:
				return children
		}
	}, [cardsInRow])

	return(
		<Tree
			{...props}
			data={data}
			NodeComponent={NodeComponent}
			allCheckBoxLabel={t('common.strings.all_selections')}
		/>
	)
}

export default CashRegisterTree
